import waitReject from './waitReject';
export default function rejectAfter(promise, ...args) {
    return Promise.race([promise, waitReject(...args)]);
}
